import currency from 'currency.js'
import { colors } from './colors'
import { StripeElementsOptions } from '@stripe/stripe-js'

export const formatPrice = (price: number, divide = 1): currency => {
  if (price === 0) return currency(price)
  return currency(price, { fromCents: true, precision: 2 }).divide(divide)
}

export const elementsAppearance: StripeElementsOptions = {
  appearance: {
    theme: 'stripe',
    variables: {
      // Typography
      fontFamily: 'stripefont, sans-serif',
      fontSizeBase: '16px',
      fontSizeXs: '16px',
      fontSizeSm: '16px',
      fontSizeLg: '16px',
      fontSizeXl: '16px',
      fontSize2Xs: '16px',
      fontSize3Xs: '16px',
      
      // Layout
      borderRadius: '10px',
      spacingUnit: '4px',
      
      // Colors
      colorPrimary: colors.blue,
      colorBackground: '#EEF4FF', // Light blue background for inputs
      colorText: colors.blue,
      colorDanger: colors.red,
      colorDangerText: colors.red,
      
      // Tab-specific colors
      colorIcon: colors.blue,
      colorIconTab: colors.blue,
    },
    rules: {
      // Input fields
      '.Input': {
        padding: '18px 16px 14px 16px',
        margin: '0 0 18px 0',
        backgroundColor: '#EEF4FF', // White background for inputs
      },
      '.Input:focus': {
        boxShadow: '0 1px 1px 0 rgba(0, 0, 0, 0.07), 0 0 0 2px var(--colorPrimary)',
      },
      '.Input::placeholder': {
        color: colors.blue30,
      },
      
      // Labels
      '.Label': {
        fontWeight: '500',
        padding: '0',
        margin: '0 0 10px 0',
        color: 'rgba(25, 20, 19, 1)',
      },
      
      // Terms text
      '.TermsText': {
        fontSize: '0.63rem',
        fontWeight: '400',
        lineHeight: '125%',
        letterSpacing: '-0.01em',
        color: 'rgba(25, 20, 19, 1)',
      },
      
      // Payment method tabs (Apple Pay, Card, etc.)
      '.Tab': {
        backgroundColor: '#FFFFFF',
        border: '1px solid #C4C4C4',
        borderRadius: '9999px', // Pill shape
        padding: '10px 24px 10px 28px', // Increased left padding
        marginBottom: '20px',
        boxShadow: 'none',
        transition: 'all 0.2s ease',
      },
      '.Tab:hover': {
        borderColor: colors.blue,
      },
      '.Tab--selected': {
        backgroundColor: '#EEF4FF',
        borderColor: colors.blue,
        borderWidth: '2px',
        padding: '9px 23px 9px 27px', // Adjust for 2px border
      },
      
      // Tab label and icon - default styling
      '.TabLabel': {
        fontWeight: '500',
        color: '#191413', // Black for unselected
        padding: '0',
        marginTop: '8px',
      },
      '.TabIcon': {
        fill: '#191413', // Black for unselected
        padding: '0',
      },
      
      // Selected state - blue (if Stripe supports these selectors)
      '.TabLabel--selected': {
        color: colors.blue,
      },
      '.TabIcon--selected': {
        fill: colors.blue,
      },
      
      // Payment method message container (appears after selection)
      '.Block': {
        backgroundColor: '#EEF4FF',
        border: '0',
        borderRadius: '20px',
        padding: '16px 20px',
        boxShadow: 'none',
        color: '#191413',
      },
      
      // Message text styling
      '.Text': {
        color: colors.blue,
      },
      '.Text--redirect': {
        color: colors.blue,
      },
    },
  },
  fonts: [
    {
      family: 'stripefont',
      src: 'url(https://app.aliveapp.co/fonts/stripe-font.woff)',
      weight: '500',
    },
  ],
}
